// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nav_nav__XCV7F {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 1rem 0;
  transition: all 0.3s ease;
  background: transparent;
}

.Nav_nav__XCV7F.Nav_scrolled__XbCwU {
  background: rgba(10, 15, 31, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(114, 43, 255, 0.1);
  padding: 0.75rem 0;
}

.Nav_container__A9FAB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 90%;
  margin: 0 auto;
}

.Nav_logo__QR8zV {
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Nav_logoImage__1KD7E {
  height: 32px;
  width: auto;
  object-fit: contain;
}

.Nav_logoText__pyIva {
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 1.5rem;
  background: #fff;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.Nav_desktopNav__HxYAI {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.Nav_links__CTxp- {
  display: flex;
  gap: 2rem;
}

.Nav_link__fadND {
  color: var(--text);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
}

.Nav_link__fadND:hover {
  color: var(--secondary);
}

.Nav_link__fadND::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  transition: width 0.3s ease;
}

.Nav_link__fadND:hover::after {
  width: 100%;
}

.Nav_mobileMenuBtn__GA3Gd {
  display: none;
  background: none;
  border: none;
  color: var(--text);
  cursor: pointer;
  padding: 0.5rem;
}

.Nav_mobileNav__gZf9Y {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(10, 15, 31, 0.95);
  backdrop-filter: blur(10px);
  padding: 1rem;
  flex-direction: column;
  gap: 1rem;
  border-top: 1px solid rgba(114, 43, 255, 0.1);
}

.Nav_mobileLink__IoszM {
  color: var(--text);
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
}

.Nav_mobileLink__IoszM:hover {
  background: rgba(114, 43, 255, 0.1);
  border-radius: 8px;
}

@media (max-width: 768px) {
  .Nav_desktopNav__HxYAI {
    display: none;
  }

  .Nav_mobileMenuBtn__GA3Gd {
    display: block;
  }

  .Nav_mobileNav__gZf9Y {
    display: flex;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Nav/Nav.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oEAAoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 1rem 0;\n  transition: all 0.3s ease;\n  background: transparent;\n}\n\n.nav.scrolled {\n  background: rgba(10, 15, 31, 0.95);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 30px rgba(114, 43, 255, 0.1);\n  padding: 0.75rem 0;\n}\n\n.container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 90%;\n  margin: 0 auto;\n}\n\n.logo {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.logoImage {\n  height: 32px;\n  width: auto;\n  object-fit: contain;\n}\n\n.logoText {\n  font-family: 'Inter', sans-serif;\n  font-weight: 800;\n  font-size: 1.5rem;\n  background: #fff;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.desktopNav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.links {\n  display: flex;\n  gap: 2rem;\n}\n\n.link {\n  color: var(--text);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n  position: relative;\n}\n\n.link:hover {\n  color: var(--secondary);\n}\n\n.link::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  transition: width 0.3s ease;\n}\n\n.link:hover::after {\n  width: 100%;\n}\n\n.mobileMenuBtn {\n  display: none;\n  background: none;\n  border: none;\n  color: var(--text);\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.mobileNav {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: rgba(10, 15, 31, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 1rem;\n  flex-direction: column;\n  gap: 1rem;\n  border-top: 1px solid rgba(114, 43, 255, 0.1);\n}\n\n.mobileLink {\n  color: var(--text);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  transition: all 0.3s ease;\n}\n\n.mobileLink:hover {\n  background: rgba(114, 43, 255, 0.1);\n  border-radius: 8px;\n}\n\n@media (max-width: 768px) {\n  .desktopNav {\n    display: none;\n  }\n\n  .mobileMenuBtn {\n    display: block;\n  }\n\n  .mobileNav {\n    display: flex;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `Nav_nav__XCV7F`,
	"scrolled": `Nav_scrolled__XbCwU`,
	"container": `Nav_container__A9FAB`,
	"logo": `Nav_logo__QR8zV`,
	"logoImage": `Nav_logoImage__1KD7E`,
	"logoText": `Nav_logoText__pyIva`,
	"desktopNav": `Nav_desktopNav__HxYAI`,
	"links": `Nav_links__CTxp-`,
	"link": `Nav_link__fadND`,
	"mobileMenuBtn": `Nav_mobileMenuBtn__GA3Gd`,
	"mobileNav": `Nav_mobileNav__gZf9Y`,
	"mobileLink": `Nav_mobileLink__IoszM`
};
export default ___CSS_LOADER_EXPORT___;
